<template>
<div>
          
        <main class="d-flex justify-content-center inicio-home">
            
            <div class="container p-5">
                <div class="row d-flex justify-content-center">
                <div class="col-md-8  bg-body rounded shadow-sm p-5">
                    <div><img class="mb-4 mx-auto d-block" src="@/assets/img/verificando.png" alt="" width="107px">
                    <p class="text-center t-v">Verificando operación</p>
                    <p class="text-center">Código de operación: <span>000015</span>  </p>
                    </div>
                        
                <div class="d-flex justify-content-between">
                        <div class="col-md-6 d-flex justify-content-start">
                            <ul class="list-ope">
                                <li class="item-op-1">Enviaste</li>
                                <li class="moneda">{{valorEnviar}}</li>
                                <li class=""> <span> {{operacion}} a:</span> {{dolar}}</li>
                            </ul>
                        </div>
                        <div class="col-md-6 d-flex justify-content-end">
                            <ul class="list-ope">
                                <li class="item-op-1">Recibiste</li>
                                <li class="moneda">{{valorRecibir}}</li>
                                <li class="">{{fecha}}</li>
                            </ul>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="col-md-6 d-flex justify-content-start">
                            <ul class="list-ope">
                                <li class="item-op-1">Nombre de la cuenta: </li>
                                <li class="">Cuenta</li>
                                <li class="">Banco</li>
                                <li class="">Tipo</li>
                                <li class="">Moneda</li>
                            </ul>
                        </div>
                        <div class="col-md-6 d-flex justify-content-end">
                            <ul class="list-ope">
                                <li class="moneda">{{banco}}</li>
                                <li class="">{{numeroCuenta}}</li>
                                <li class="">{{banco}}</li>
                                <li class="">Corriente</li>
                                <li class="">{{tipocuenta}}</li>
                            </ul>
                        </div>
                     </div>
                </div>
            </div>
            </div>
        </main>
   
</div>
</template>

<script>
    import moment from 'moment'

  export default {
    name: "DetalleOperaciones",

    data() {
    return {
      valorEnviar:localStorage.getItem("valorEnviar"),
      valorRecibir:localStorage.getItem("valorRecibir"),
      operacion:localStorage.getItem("operacion"),
      dolar:localStorage.getItem("dolar"),
      fecha:moment(new Date()).local().format('DD/MM/YYYY'),
      banco:localStorage.getItem("banco"),
      tipocuenta:localStorage.getItem("tipocuenta"),
      numero:localStorage.getItem("numeroOperacion"),
      numeroCuenta:localStorage.getItem("numeroCuenta"),
      
    };
  },
    methods:{
        
    },
  };
  </script>


// WEBPACK FOOTER //
// src/components/user/DetalleOperaciones.vue